/* build-stamp: 20260723T213947Z */
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import reportWebVitals from "@/reportWebVitals";
import { registerServiceWorker } from "@/lib/registerServiceWorker";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Kick off Core Web Vitals reporting after render so it never delays the
// first paint. Fires LCP/INP/CLS/FCP/TTFB events at /api/public/track as
// they finalize (typically on tab-hide or user interaction).
reportWebVitals();

// PWA — register the service worker (production builds only). Gives us
// offline app-shell + hot-API caching + install-to-home-screen support.
registerServiceWorker();
